// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"547111a6","656":"551b147a","684":"2e5496cf","710":"a1abca14","756":"c0cd6303","787":"c13d037c"}[chunkId] + ".chunk.js";
};